import React, { Component, Fragment } from 'react';
import { Grid, Button, Row, Col, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import TickerSearch from './TickerSearch/TickerSearch';
import ClearHistoryModal from '../../containers/TradeHistory/ClearHistoryModal';
import { clearTradeHistory } from '../../actions';
import './SubNav.css';

class SubNavTradeHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showClearHistoryModal: false
    };
  }

  openModal = () => {
    this.setState({ showClearHistoryModal: true });
  }

  closeModal = () => {
    this.setState({ showClearHistoryModal: false });
  }

  onClearTradeHistory = () => {
    this.props.clearTradeHistory({ 
      portfolioId: this.props.session.activePortfolioUser.portfolio_id
    });
    this.closeModal();
  }

  notReadonly = () => {
    if (this.props.session.activePortfolioUser.privilege !== 'readonly') {
      return (
        <Fragment>
          <Button
            onClick={this.props.refreshHistory}>
            <Glyphicon style={{ fontSize: 10 }} glyph="refresh" />
          </Button>

          <Button
            onClick={this.props.openAddTradeHistoryModal}>
            Add to History
          </Button>

          <Button
            onClick={this.openModal}>
            Clear History
          </Button>
        </Fragment>
      );
    }
  }

  render() {

    if (!this.props.auth.authenticated) return null;
    if (this.props.session.isAccountEmpty === null) return null;

    return (
      <Grid fluid id="sub-nav">

        <ClearHistoryModal
          showClearHistoryModal={this.state.showClearHistoryModal}
          closeModal={this.closeModal} 
          clearTradeHistory={this.onClearTradeHistory} />

        <Row>
          <Col md={7} className="section section-left">

            {this.notReadonly()}

          </Col>
          <Col md={5} className="section section-right">
            <TickerSearch />
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps({ auth, session }) {
  return {
    auth,
    session
  }
}

export default connect(mapStateToProps, { clearTradeHistory })(SubNavTradeHistory);